'use client';

import { useFeatureFlags } from '@mf/common/contexts/feature-flags/providers/feature-flags.context';
import { ClientHeader, ClientHeaderProps } from './Header';
import { ClientHeaderV2, ClientHeaderV2Props } from './HeaderV2';

export const HeaderLayout = (
  props: ClientHeaderProps & ClientHeaderV2Props,
) => {
  const { isEnabled } = useFeatureFlags();

  return (
    <>
      {isEnabled('header-v2') ? (
        <ClientHeaderV2
          megaMenuItems={props.megaMenuItems}
          menuItems={props.menuItems}
          isAuthenticated={props.isAuthenticated}
          customerData={props.customerData}
          showSearchButton={props.showSearchButton}
        />
      ) : (
        <ClientHeader
          menuItems={props.menuItems}
          isAuthenticated={props.isAuthenticated}
          customerData={props.customerData}
          showSearchButton={props.showSearchButton}
        />
      )}
    </>
  );
};
